import React, { useState, useEffect } from "react";
import logo from "./logo.svg";
import "./App.css";
import SearchBar from "./components/SearchBar";
import ScoreBoard from "./components/ScoreBoard";
import Criteria from "./components/Criteria";

function App() {
  const [selectedClub, setSelectedClub] = useState(null);
  const [score, setScore] = useState(null);
  const [blur, setBlur] = useState(true);
  const [criteriaChecked, setCriteriaChecked] = useState(false);
  const [shouldWatch, setShouldWatch] = useState(true);
  // const [teams, setTeams] = useState([]);

  // useEffect(() => {
  //   const fetchTeams = async () => {
  //     try {
  //       const response = await fetch(
  //         "https://api-football-v1.p.rapidapi.com/v3/teams?season=2022&league=61",
  //         {
  //           method: "GET",
  //           headers: {
  //             "X-RapidAPI-Key": process.env.REACT_APP_API_KEY,
  //             "X-RapidAPI-Host": "api-football-v1.p.rapidapi.com",
  //           },
  //         }
  //       );
  //       const data = await response.json();
  //       setTeams(data.response);
  //       console.log(data);
  //     } catch (err) {
  //       console.error(err);
  //     }
  //   };

  //   fetchTeams();
  // }, []);

  const fetchScore = async (club) => {
    try {
      const response = await fetch(
        `https://api-football-v1.p.rapidapi.com/v3/fixtures?team=${club.id}&last=1&status=FT-AET-PEN`,
        {
          method: "GET",
          headers: {
            "X-RapidAPI-Key": process.env.REACT_APP_API_KEY,
            "X-RapidAPI-Host": "api-football-v1.p.rapidapi.com",
          },
        }
      );
      const data = await response.json();
      setScore(data);
      console.log(data);
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <div className="App">
      <div className="flex-column main-container">
        <div className="flex-column hero">
          <div className="flex-column hero-headings">
            <h1>Watch or not?</h1>
            <h2>
              No spoilers - find out if you should still watch that game you
              recorded
            </h2>
          </div>
          <SearchBar
            setSelectedClub={setSelectedClub}
            setCriteriaChecked={setCriteriaChecked}
            setShouldWatch={setShouldWatch}
            onSubmit={fetchScore}
            setBlur={setBlur}
          />
        </div>

        {selectedClub ? (
          <>
            <Criteria
              score={score}
              setCriteriaChecked={setCriteriaChecked}
              setShouldWatch={setShouldWatch}
            />
            <ScoreBoard
              score={score}
              selectedClub={selectedClub}
              setBlur={setBlur}
              blur={blur}
              criteriaChecked={criteriaChecked}
              shouldWatch={shouldWatch}
            />
          </>
        ) : (
          <h3>Select a club first...</h3>
        )}
      </div>
    </div>
  );
}

export default App;
